import { Box, Checkbox } from "@mui/material";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import { PatientNotificationPreference } from "../../../../../services";
import { applyDefaultColumnSettings } from "../../../../../utils/utils";

type Channel = "push" | "text" | "email";

interface NotificationTableProps {
  list: PatientNotificationPreference[];
  onChangePreference: (notificationTypeId: number, channel: Channel) => void;
  customHeight?: any;
  loading?: boolean;
}

const columns = (
  onChangePreference: NotificationTableProps["onChangePreference"]
) =>
  applyDefaultColumnSettings<PatientNotificationPreference>([
    {
      field: "notificationTypeName",
      headerName: "Type",
      flex: 0.3,
      minWidth: 240,
      sortable: false,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 0.2,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "push",
      headerName: "Push",
      flex: 0.25,
      minWidth: 80,
      sortable: false,
      renderCell: (params: any) => (
        <Checkbox
          checked={!!params.row.push}
          onChange={() =>
            onChangePreference(params.row.notificationTypeId, "push")
          }
        />
      ),
    },
    {
      field: "text",
      headerName: "Text",
      flex: 0.25,
      minWidth: 80,
      sortable: false,
      renderCell: (params: any) => (
        <Checkbox
          checked={!!params.row.text}
          onChange={() =>
            onChangePreference(params.row.notificationTypeId, "text")
          }
        />
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 0.2,
      minWidth: 80,
      sortable: false,
      renderCell: (params: any) => (
        <Checkbox
          checked={!!params.row.email}
          onChange={() =>
            onChangePreference(params.row.notificationTypeId, "email")
          }
        />
      ),
    },
  ]);

const NotificationTable = ({
  list,
  onChangePreference,
  customHeight,
  loading,
}: NotificationTableProps) => {
  const rows = list.map((pref) => ({
    ...pref,
    id: pref.notificationTypeId,
  }));

  return (
    <Box width={"100%"} height={customHeight ?? "100%"}>
      <CustomDataGridV2
        loading={loading}
        rows={rows}
        columns={columns(onChangePreference)}
        disableRowSelectionOnClick
        rowHeight={60}
      />
    </Box>
  );
};

export default NotificationTable;
